<!-- Pocas operaciones -->
@if (balanceStatus === 'low') {
<tec-tile
    type="banner-horizontal"
    img="images/operation-balance-low-ops.png"
    [title]="'PANEL.OPERATION_BALANCE.LOW_OPERATIONS.TITLE' | translate"
    [subtitle]="'PANEL.OPERATION_BALANCE.LOW_OPERATIONS.SUBTITLE' | translate"
>
    <tec-button
        type="secondary"
        [label]="'PANEL.OPERATION_BALANCE.BUTTON' | translate"
        (clickEvent)="openContactForm()"
    />
</tec-tile>
}

<!-- Saldo agotado -->
@if (balanceStatus === 'depleted') {
<tec-alert
    [msg]="'PANEL.OPERATION_BALANCE.OUT_OF_BALANCE.MSG' | translate"
    [status]="'default'"
    [hiddenCloseButton]="true"
    [buttonLabel]="'PANEL.OPERATION_BALANCE.BUTTON' | translate"
    (buttonClicked)="openContactForm()"
/>
}

<!-- MODAL CONTACTO EXPERTO -->
@if (showModalContactExpert) {
<app-modal-contact-expert (closeEvent)="closeModalContactExpert()" />
}
